import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDishTypeAlternativeIngredientsDetailsArgs } from '../graphql/transformers'
import { UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS } from '../redux/action-types'

const useUpdateDishTypeAlternativeIngredientsDetailsMutation = () => {
  const dispatch = useDispatch()

  const {
    isAlternativeIngredientsDetailsLoading,
    alternativeIngredientsDetailsError,
  } = useSelector(store => store.dishTypes.dishType)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateDishTypeAlternativeIngredientsDetailsArgs(
            data,
          ),
        },
        dispatch,
        UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isAlternativeIngredientsDetailsLoading,
      error: alternativeIngredientsDetailsError,
    },
  ]
}

export default useUpdateDishTypeAlternativeIngredientsDetailsMutation
